import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "mb-2 text-sm text-primary ml-0.5" }, "Estado de Mii importados a base de datos", -1)
const _hoisted_2 = { class: "flex mb-5 flex-wrap" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center text-primary font-bold flex flex-col" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text-xs" }, "Periodo seleccionado", -1)
const _hoisted_7 = { class: "text-2xl" }
const _hoisted_8 = {
  key: 0,
  class: "text-center my-1 text-gray-300"
}
const _hoisted_9 = { class: "mt-4 text-center text-sm mb-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_ui_modal = _resolveComponent("ui-modal")

  return (_openBlock(), _createBlock("section", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
        return (_openBlock(), _createBlock("div", {
          class: "w-1/6 select-none cursor-pointer",
          key: month
        }, [
          _createVNode("div", {
            class: "border-2 border-gray-200 px-3 py-1 rounded-md m-0.5 flex justify-between align-center hover:bg-gray-100",
            onClick: ($event: any) => (_ctx.showMonthModal(month))
          }, [
            _createVNode("span", _hoisted_3, _toDisplayString(month.month), 1),
            (month.db)
              ? (_openBlock(), _createBlock(_component_fa_icon, {
                  key: 0,
                  icon: ['fas', 'check'],
                  class: "pt-1 text-primary"
                }))
              : (_openBlock(), _createBlock(_component_fa_icon, {
                  key: 1,
                  icon: ['fas', 'times'],
                  class: "pt-1 text-red-500"
                }))
          ], 8, ["onClick"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_ui_modal, {
      modalState: _ctx.modalState,
      "onUpdate:modalState": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalState = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.selectedMonth)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("p", _hoisted_5, [
                _hoisted_6,
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedMonth.month), 1)
              ]),
              (_ctx.loadingExtraData && _ctx.updating.total > 0)
                ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.updating.actual) + "/" + _toDisplayString(_ctx.updating.total), 1))
                : _createCommentVNode("", true),
              _createVNode("p", _hoisted_9, [
                (!_ctx.selectedMonth.db && _ctx.selectedMonth.exists)
                  ? (_openBlock(), _createBlock("span", _hoisted_10, " Vas a cargar los datos de este periodo a las guias respectivas "))
                  : _createCommentVNode("", true),
                (_ctx.selectedMonth.db && _ctx.selectedMonth.exists)
                  ? (_openBlock(), _createBlock("span", _hoisted_11, " Ya existen datos de este periodo asociado a las guias, con esta acción sobre-escribirás los datos previos "))
                  : _createCommentVNode("", true),
                (!_ctx.selectedMonth.exists)
                  ? (_openBlock(), _createBlock("span", _hoisted_12, " No existen datos base del Mii para este periodo, no hay datos disponibles para asociar "))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ui_button, {
                label: "Cargar Datos",
                disabled: !_ctx.selectedMonth || !_ctx.selectedMonth.exists,
                loading: _ctx.loadingExtraData,
                onClick: _ctx.requestLoadExtraData
              }, null, 8, ["disabled", "loading", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modalState"])
  ]))
}